/**
 * packageRefs.js (WP-4)
 *
 * Derive package refs from the AUTHORED (unexpanded) designer payload for the
 * package-linkage registry. Every 📦 node yields one ref keyed by its node id;
 * nodes with a null packageId (legacy .sampkg imports never bound to a cloud
 * package) are skipped — they have no cloud identity to register against.
 */
export function derivePackageRefsFromPayload(nodes = []) {
  return nodes
    .filter((n) => n.type === 'package' && n.data && n.data.packageId)
    .map((n) => ({
      package_id: n.data.packageId,
      package_version: n.data.packageVersion ?? null,
      node_id: n.id,
    }));
}
